import { render } from "./QuestionWrapper.vue?vue&type=template&id=1fdc38c1&ts=true"
import script from "./QuestionWrapper.vue?vue&type=script&lang=ts"
export * from "./QuestionWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__